import { store } from "@/vuex/store.js"
import { axiosGet, axiosPost,axiosPut, axiosDelete } from "../options/header"


export default {
  getAllInstitucije() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije",
        {
           credentials: true
        });
    } catch (err) {
      console.log(err);
    }
  },
  getAllInstitucijeShort() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije/short",
      {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  getSingleInstitucija(oib) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije/" + oib,
      {
        
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
  async getSingleInstitucijaComunication(oib) {
    let accessToken = store.state.aToken
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije/" + oib + "/comunication", {
        params: {
          accessToken,
        },
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

  quickAddInstitucija(institucija) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije/quick", {
        params: {
          institucija
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addInstitucija(institucija) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije", {
        params: {
          institucija
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  updateInstitucija(institucija, uid) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije/" + uid, {
        params: {
          institucija
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteInstitucija(uid) {
    try {
      return axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/institucije/" + uid, {
         credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },
}